import { Box, Typography } from '@mui/material';
import CollapsibleComponent from "./collapsibleComponents";
import { CustomerDetailResponse } from '../../interfaces/customerDetail';

export const ReferenceContactsSection = ({ title, detailMap }: {
    title: string;
    detailMap: Map<string, Map<string, CustomerDetailResponse[]>>;
}) => {
    if (!detailMap) return null;

    return (
        <CollapsibleComponent
            key={title}
            headerText={title}
            headerStyle={{ backgroundColor: '#FFEBE5' }}
            content={
                <Box>
                    {Array.from(detailMap.entries()).map(([fieldId, groupMap]) => {
                        const anyDetail = groupMap.values().next().value?.[0];
                        const fieldName = anyDetail?.customer_detail_field?.field_name || fieldId;

                        return (
                            <Box key={fieldId} mt={2}>
                                <Typography variant="h5" gutterBottom>
                                    {fieldName}
                                </Typography>

                                <Box display="flex" flexWrap="wrap" gap={2}>
                                    {Array.from(groupMap.entries()).map(([groupId, details]) => (
                                        <Box
                                            key={groupId}
                                            border="1px solid #ccc"
                                            borderRadius="8px"
                                            padding="16px"
                                            width="300px"
                                        >
                                            <Typography
                                                variant="subtitle1"
                                                fontWeight="bold"
                                                display="flex"
                                                alignItems="center"
                                                gap={1}
                                            >
                                                {details[0].customer_detail_field.field_name}
                                            </Typography>

                                            {details.map((detail, idx) => (
                                                <Box key={idx} mt={1}>
                                                    <Typography>
                                                        <strong>{detail.field.field_name}:</strong>{" "}
                                                        {detail.customer_detail.field_value}
                                                    </Typography>
                                                </Box>
                                            ))}
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        );
                    })}
                </Box>
            }
        />
    );
};
